<script setup>
import JournalHistory from '../components/monitoring/JournalHistory.vue'
</script>
<template><JournalHistory journal="runs" /></template>
